import { Badge } from '@/components/ui/badge';
import type { Lead } from '@/models/entities/lead.ts';
import { urgencyFromLead } from '@/models/entities/workflowExtensions';
import { UrgencyFilterEnum } from '@/models/ui/filterChip.ts';

export interface LeadDueDateBadgeProps {
  readonly lead: Lead;
}

export function LeadDueDateBadge({ lead }: LeadDueDateBadgeProps) {
  const urgency = urgencyFromLead(lead);

  if (urgency === UrgencyFilterEnum.enum.Overdue) {
    return <Badge variant="overdue">Overdue</Badge>;
  }

  if (urgency === UrgencyFilterEnum.enum.OverdueSoon) {
    return <Badge variant="overdueSoon">Overdue Soon</Badge>;
  }

  return null;
}
